import { useMutation, useQueryClient } from 'react-query'
import { config } from 'config'
import { callAxios, CustomAxiosError } from 'utils/api'
import { MessageStatusResponse } from 'pages/admin/supplierMessaging/types'

const { SECURE_BASE_URL } = config!

const deleteMessage = async (id: string): Promise<MessageStatusResponse> => {
  const { response: deleteMessageResponse } = await callAxios<{
    response: MessageStatusResponse
  }>({
    url: `${SECURE_BASE_URL}/deleteMessage`,
    method: 'DELETE',
    data: {
      id,
      operation: 'delete',
    },
  })

  return deleteMessageResponse
}

export const useDeleteMessage = () => {
  const queryClient = useQueryClient()

  const {
    status: getDeleteMessageStatus,
    data: deleteMessageData,
    error: getDeleteMessageError,
    mutate: mutateDeleteMessage,
  } = useMutation<MessageStatusResponse, CustomAxiosError, string>(deleteMessage, {
    onSuccess: () => {
      return queryClient.invalidateQueries('supplierMessages/get')
    },
  })

  return {
    getDeleteMessageStatus,
    deleteMessageData,
    getDeleteMessageError,
    mutateDeleteMessage,
  }
}
